export default [
	{
		path: 'list',
		name: 'erp_product_list',
		component: () => import('@/pages/erp/product_list')
	},
	{
		path: 'push',
		name: 'erp_push_list',
		component: () => import('@/pages/erp/push_list')
	},
	{
		path: 'auctionPush',
		name: 'erp_auction_push_report',
		component: () => import('@/pages/erp/auction_push_report')
	},
	{
		path: 'auctionStat',
		name: 'erp_auction_stat_report',
		component: () => import('@/pages/erp/auction_stat_report')
	}
];
